import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center font-medium transition-all duration-200 ease-luxury focus:outline-none focus:ring-2 focus:ring-gold-400 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-primary-900 text-white hover:bg-primary-800 rounded-2xl shadow-soft',
        secondary: 'bg-pearl-100 text-primary-900 border border-primary-200 hover:bg-pearl-200 rounded-2xl',
        ghost: 'bg-transparent text-primary-900 hover:bg-primary-50 rounded-2xl',
        luxury: 'bg-gold-500 text-[#0e302d] hover:bg-gold-600 rounded-2xl shadow-gold',
        danger: 'bg-danger-500 text-white hover:bg-danger-700 rounded-2xl',
      },
      size: {
        sm: 'px-4 py-2 text-base',
        md: 'px-5 py-3 text-base',
        lg: 'px-6 py-4 text-lg',
      },
      fullWidth: {
        true: 'w-full',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
      fullWidth: false,
    },
  }
);

const Button = React.forwardRef(({
  className,
  variant,
  size,
  fullWidth,
  ...props
}, ref) => (
  <button
    ref={ref}
    className={cn(buttonVariants({ variant, size, fullWidth }), className)}
    {...props}
  />
));

Button.displayName = 'Button';

export { Button, buttonVariants };
